import TabsPage from '../TabsPage';

import './index.less';
import './themes/default.less';

import ContentBlock from "components/ContentBlock";

export default class Anketa extends TabsPage {
    constructor(props) {
        super(props);

        this.defaultHistory = {
            createdBy: null,
            createdTime: null,
            changedBy: null,
            changedTime: null,
        };

        this.state = {
            ...this.state,
            absol: false,
            historyAdult: { ...this.defaultHistory },
            historyChildren: { ...this.defaultHistory },
            info: {
                adultAnket: [],
                childAnket: [],
            }
        };
    }

    componentDidMount() {
        this.refresh();
    }

    updateAnket() {
        this.refresh();
    }

    refresh() {
        this.getData();
    }

    async getData() {
        this._helper.showLoading();

        const { id, domainId } = this.props.info;
        const resp = await this._request.anketaQuestionnaireStat.getClientAnketa(id);
        const items = resp?.data || [];

        let historyAdult = this.defaultHistory;
        let historyChildren = this.defaultHistory;
        let adultAnket = [];
        let childAnket = [];

        if (items.length > 0) {
            adultAnket = items.filter(it => it.anketaId === 1);
            childAnket = items.filter(it => it.anketaId === 2);

            if (adultAnket.length > 0)
                historyAdult = adultAnket[0];

            if (childAnket.length > 0)
                historyChildren = childAnket[0];
        }

        const info = { id, domainId, adultAnket, childAnket };

        this.setState({ historyAdult, historyChildren, info });

        this._helper.hideLoading();
    }

    async print(name, type) {
        const { /*id, */adultAnket, childAnket } = this.state.info;
        /*this.printShow(name, {
            clientId: id + "",
            anketaId: type + "",
        });*/

        const { birthday, doctorId, phoneNumber } = this.props.info;
        const fio = this._helper.string.formatFullName(this.props.info);
        const doctor = this._helper.string.formatFullName(this.props.getDoctorById(doctorId));

        const printInfo = {
            fio,
            birthday,
            doctor,
            phone: phoneNumber,
            adultAnket,
            childAnket,
            type
        };

        this._print.anketa(printInfo);
    }

    renderAnket(items) {
        return (
            <div className="content flex col gap16">
                {items.map((it, i) => this.renderRow(it.question, <div>{it.value ? it.value : it.anketaQuestionAnswer.title}</div>, false, i))}
            </div>
        );
    }

    renderHistoryRow(type, obj) {
        const { changedBy, changedTime, createdBy, createdTime } = obj;

        const ankCreated = createdBy ? `${this._helper.string.formatFullName(this.props.getDoctorById(createdBy), "short")} ${this._helper.date.toStr(createdTime, "D MMMM YYYY")}` : "";
        const ankUpdated = changedBy ? `${this._helper.string.formatFullName(this.props.getDoctorById(changedBy), "short")} ${this._helper.date.toStr(changedTime, "D MMMM YYYY")}` : "";

        return (<div className="content flex col gap8">
            {this.renderRow(`client.ank${type}Created`, <div>{ankCreated}</div>)}
            {this.renderRow(`client.ank${type}Updated`, <div>{ankUpdated}</div>)}
        </div>);
    }

    renderHistory() {
        const { historyAdult, historyChildren } = this.state;

        return (
            <div className="content flex col gap24">
                {this.renderHistoryRow("Adult", historyAdult)}
                {this.renderHistoryRow("Child", historyChildren)}
            </div>
        );
    }

    renderContent() {
        const { openRightPopup } = this.props;
        const { info } = this.state;
        const { adultAnket, childAnket } = info;

        return (
            <div className="flex1 flex col gap24">
                <div className="titleBlock text blockTitle">
                    {this.tr("client.ank")}
                </div>
                <div className="flex1 flex gap16">
                    <div className="flex col flex1 gap16">
                        {adultAnket.length > 0 ? <ContentBlock
                            title="client.ankAdult"
                            icons={[
                                { name: "print", onClick: this.print.bind(this, "Anketa_answers", 1) },
                                { name: "edit", onClick: openRightPopup.bind(this, "anketa", info, "ankAdult", this.updateAnket.bind(this)) }
                            ]}
                        >
                            {this.renderAnket(adultAnket.filter(it => it.value || (it.anketaQuestionAnswer && it.anketaQuestionAnswer.title)))}
                        </ContentBlock> : <ContentBlock
                            title="client.ankAdult"
                            icon={{ name: "plus", onClick: openRightPopup.bind(this, "anketa", info, "ankAdult", this.updateAnket.bind(this)) }}
                            border="dashed"
                        />}


                    </div>
                    <div className="flex col flex1 gap16">
                        {childAnket.length > 0 ? <ContentBlock
                            title="client.ankChild"
                            icons={[
                                { name: "print", onClick: this.print.bind(this, "Anketa_answers", 2) },
                                { name: "edit", onClick: openRightPopup.bind(this, "anketa", info, "ankChild", this.updateAnket.bind(this)) }
                            ]}
                        >
                            {this.renderAnket(childAnket.filter(it => it.value || it.anketaQuestionAnswer.title))}
                        </ContentBlock> : <ContentBlock
                            title="client.ankChild"
                            icon={{ name: "plus", onClick: openRightPopup.bind(this, "anketa", info, "ankChild", this.updateAnket.bind(this)) }}
                            border="dashed"
                        />}
                        <ContentBlock title="client.history">
                            {this.renderHistory()}
                        </ContentBlock>
                    </div>
                </div>
            </div>
        );
    }
}
